import { Flex } from '@haldor/ui';
import {
	archiveConversation,
	clearSearch,
	getArchivedConversations,
	getConversations,
	searchConversation,
	updateSearchedConversations,
	stageConversation
} from 'actions/conversation';
import { getUserNotificationSettings } from 'actions/user';
import { getMyOwnedEducationGroups } from 'actions/groups';
import Redirect from 'components/Redirect/Redirect';
import Modal from 'containers/Modals/Modal';
import Moment from 'moment';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { Collapsible, Person } from 'UI';
import { Search } from 'UI/Inputs';
import { Icon, Button } from '@haldor/ui';
import LoadingCards from 'components/Cards/LoadingCard';
import User from '_class/User';
import '../Conversation.scss';
import SelectRecipientForm from '../Form/SelectRecipient';
import { getConversationParticipants } from '../Helpers';
import { setPageTitle, setPageActions } from 'actions/header';
import NotificationOptionForm from 'containers/Forms/NotificationOptionForm';


class ConversationsPage extends Component {

	/* Class setup */
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			searching: false,
			searchView: false,
			myEducationGroups: [],
			loading: false,
			loadingArchievedConversation: false,
			optionsModalVisible: false,
			user: new User(this.props.user)
		};
	}

	async componentDidMount() {
		this.setState({ loading: true });

		await this.props.getConversations();

		let myEducationGroups = await this.props.getMyOwnedEducationGroups();
		this.setState({ myEducationGroups: myEducationGroups, loading: false });

		this.props.setPageTitle(this.props.translate('messages'));

		let headerButtons = [];
		if (this.state.user.isMentor() || this.state.user.isTeacher() || this.state.user.isStudent()) {
			headerButtons.push({
				value: this.props.translate('Write new'),
				onClick: this.toggleModal,
				type: 'button',
				icon: 'plus',
			});
		}

		if (this.state.user.isMentor() || this.state.user.isTeacher()) {
			await this.props.getUserNotificationSettings();

			if (this.props.userNotificationSettings != null && this.props.userNotificationSettings.length > 0) {
				headerButtons.push({
					value: this.props.translate('Options'),
					type: 'button',
					onClick: this.toggleOptionModal,
					icon: 'cog_bw',
				});
			}
		}

		this.props.setPageActions(headerButtons);
	}

	componentWillUnmount = () => {
		this.props.clearSearch();
	}

	toggleOptionModal = () => {
		this.setState({ optionsModalVisible: !this.state.optionsModalVisible });
	}


	closeOptionsModal = () => {
		this.setState({ optionsModalVisible: false });
	}

	/* Events */
	toggleModal = () => {
		this.setState({ modal: !this.state.modal });
	}

	onSelectRecipients = (values) => {
		return new Promise(() => {
			// Create conversation API request hereee
			let conversation = {
				title: '',
				status: 'ACTIVE',
				memberships: values.memberships,
				messages: [],
				relationships: values.relationships,
				id: 'new',
			};

			this.props.stageConversation(conversation)
				.then(() => {
					this.setState({ modal: false });
					this.props.history.push(`/conversations/new`);
				});
		});
	}

	onSearch = (query) => {
		if (query.query.length == 0) {
			this.props.clearSearch();
			this.setState({ searchView: false });
			this.props.setPageTitle(this.props.translate('conversations'));
			return;
		}

		if (query.query.length < 2) {
			return;
		}

		this.setState({ searching: true, searchView: true });
		this.props.searchConversation(query.query).then(() => {
			this.props.setPageTitle(this.props.translate('search-result'));
			this.setState({ searching: false });
		});
	}

	archiveConversation = (event, conversation) => {
		event.preventDefault();
		event.stopPropagation();

		if (conversation == null) {
			return;
		}

		swal.fire({
			title: this.props.translate('are-you-sure'),
			text: this.props.translate('conversation-archive-message'),
			showCancelButton: true,
			cancelButtonText: this.props.translate('Cancel'),
			confirmButtonText: this.props.translate('Remove'),
		}).then(response => {
			if (response.value != null) {
				this.props.archiveConversation(conversation);
				if (this.props.results != null && this.props.results.length > 0) {
					this.props.updateSearchedConversations(this.props.results)
				}
			}
		});

	}

	/* Render methods */
	renderConversation = (conversation, index) => {
		const participants = getConversationParticipants(conversation, this.props.user);
		const user = new User(this.props.user);
		let message = null;
		let timeOfLastMessage = null;
		if (conversation.messages.length > 0 && conversation.messages[conversation.messages.length - 1] != null) {
			let lastMessage = conversation.messages[conversation.messages.length - 1];
			timeOfLastMessage = lastMessage.created;
			if (lastMessage.flagID != null) {
				message = <span style={{ fontStyle: 'italic' }}>
					{this.props.translate('Message is reported as inappropriate.')}
				</span>
			} else {
				message = lastMessage.text.replace(/(<([^>]+)>)/ig, '');
				if (message.length > 155) {
					message = message.substring(0, 155) + '...';
				}
			}
		}

		let canEdit = false;

		const foundSection = participants?.find(p => p.membershipType === 'SECTION_OWNERS');

		if (foundSection && !user.isStudent()) {
			canEdit = this.state.myEducationGroups.some(q => String(q.Id) === String(foundSection.Id));
		} else if (!user.isStudent()) {
			const findUserAsParticipant = conversation.memberships?.find(m => String(m.membershipID) === String(user.getUserId()));
			if (findUserAsParticipant?.permission) {
				canEdit = findUserAsParticipant.permission.toUpperCase() === 'O';
			}
		}

		return <Link key={'conversation' + index} to={`/conversations/${conversation.id}`} className="conversation-container">
			<div className="participants">
				<div>
					{participants.map((participant, index) => {

						if (participant != null) {
							if (participant.membershipType == 'SECTION_OWNERS') {
								return <Person
									person={{
										firstName: participant.title + ' (' + this.props.translate('Staff') + ')',
										lastName: '',
										...participant
									}}
									key={participant.id}
								/>
							}

							if (participant.membershipType == 'GUARDIAN') {
								if (participant?.userId === undefined) {
									participant.lastName = ' (' + this.props.translate('inactive') + ' ' + this.props.translate('guardian') + ')';
								} else {
									participant.lastName = (participant.lastName != null ? participant.lastName : '') + ' (' + this.props.translate('Guardian') + ')';
								}
							}

							return <Person person={participant} key={'person-' + index + '-' + participant.userId} showEmail={true} />

						}
					})}
				</div>

				{conversation.status.toUpperCase() == 'ACTIVE' && !user.isStudent() && canEdit ?
					<div>
						<span onClick={(e) => this.archiveConversation(e, conversation)}>
							<Icon name="Bin" />
						</span>
					</div>
					: null}
			</div>
			<div className="message-container">
				<div className="latest-message">
					{conversation.unreadMessages > 0 ? (
						<span className="badge" style={{ display: 'inline-flex', transform: 'none', position: 'static', justifyContent: 'center', borderRadius: '100%', marginRight: '0.4rem' }}>{conversation.unreadMessages}</span>

					) : null}

					{message != null ? message : null}
				</div>

				{timeOfLastMessage != null ? (
					<div className="card-meta">
						{Moment.utc(timeOfLastMessage).local().format('yyyy-MM-DD HH:mm')}
					</div>
				) : null}
			</div>
		</Link >
	}

	async toggleOpen() {
		if (this.props.archived == null) {
			this.setState({ loadingArchievedConversation: true });
			await this.props.getArchivedConversations();
			this.setState({ loadingArchievedConversation: false });
		}
	}

	render() {
		if (!this.props.services.conversations) {
			return <Redirect to="/" />
		}

		let notificationSettings = [];

		if (this.props.userNotificationSettings != null && this.props.userNotificationSettings.length > 0) {
			// Filter the notification settings for "NOTIFICATION_GUARDIANS_MESSAGE"
			notificationSettings = this.props.userNotificationSettings.filter((setting) => {
				return setting.settingName === "NOTIFICATION_GUARDIANS_MESSAGE";
			}).map((setting) => {
				// Set 'enabled' to true if setting.id == 0, because by default it will send notification.
				setting.enabled = setting.id === 0 ? true : setting.enabled;
				return setting;
			});
		}

		let conversations = null;
		let archived = null;

		if (this.props.conversations != null && this.props.conversations.length > 0) {
			conversations = this.props.conversations.filter(conversation =>
				conversation.status != 'ARCHIVED'
			)

			archived = this.props.conversations.filter(conversation =>
				conversation.status == 'ARCHIVED'
			)
		}

		if (archived != null && this.props.archived && this.props.archived.length > 0) {
			archived = this.props.archived.concat(archived);
			archived.sort((a, b) => {
				const dateB = b.edited ? new Date(b.edited).getTime() : (b.created ? new Date(b.created).getTime() : 0);
				const dateA = a.edited ? new Date(a.edited).getTime() : (a.created ? new Date(a.created).getTime() : 0);
				return dateB - dateA;
			});

		} else {
			archived = this.props.archived;
		}

		return (
			<div className="section" style={{ padding: 0, margin: 0, border: 0 }}>
				<Modal onClose={this.toggleModal} overridePrompt title={this.props.translate('new-message')} isOpen={this.state.modal} type="small">
					<SelectRecipientForm onSubmit={this.onSelectRecipients} />
				</Modal>

				<Modal
					isOpen={this.state.optionsModalVisible}
					onClose={this.closeOptionsModal}
					title={this.props.translate('Options')}
					type="small news"
				>
					<NotificationOptionForm
						onAbort={this.closeOptionsModal}
						values={notificationSettings}
					/>
				</Modal>

				<div className="overview">
					<div className="conversation conversation--wrapper">
						<div className="conversation-list">
							<Flex center space>
								<div style={{ flex: '1' }}>
									<Search
										onSubmit={this.onSearch}
										loading={this.state.searching}
										placeholder={this.props.translate('search-for-conversation')}
										autoSearch
										allowEmpty
									/>
								</div>
							</Flex>
							{this.state.loading ?
								<LoadingCards count={1} />
								:
								this.props.results != null && this.state.searchView ?
									this.props.results.map((conversation, index) => {
										return this.renderConversation(conversation, index);
									})
									:
									conversations != null && conversations.length > 0 ?
										conversations.map((conversation, index) => {
											return this.renderConversation(conversation, index);
										})
										: null
							}


							<div className="archived-conversations">
								<Collapsible onChange={(open) => this.toggleOpen()} trigger={this.props.translate('Removed')}>
									{this.state.loadingArchievedConversation ? <LoadingCards count={1} /> : null}

									{!this.state.loadingArchievedConversation && archived != null && archived.length > 0 ? <div>
										{archived.map((conversation, index) => {
											return this.renderConversation(conversation, index);
										})}
									</div> : null}
								</Collapsible>
							</div>


						</div>
					</div>
				</div>
			</div>
		);
	}

}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		user: state.user.currentUser,
		conversations: state.Conversation.conversations,
		archived: state.Conversation.archived,
		results: state.Conversation.searchResults,
		services: state.Services.availableServices,
		userNotificationSettings: state.user.userNotificationSettings
	}
}

export default withRouter(connect(mapStateToProps, {
	getConversations,
	stageConversation,
	searchConversation,
	clearSearch,
	archiveConversation,
	getArchivedConversations,
	updateSearchedConversations,
	setPageTitle,
	setPageActions,
	getMyOwnedEducationGroups,
	getUserNotificationSettings
})(ConversationsPage));